export const fourMarlaImages = [
    "/4 Marla/1.png",
    "/4 Marla/2.png",
    "/4 Marla/3.png",
    "/4 Marla/4.png",
    "/4 Marla/5.png",
    "/4 Marla/6.png",
    "/4 Marla/7.png",
    "/4 Marla/8.png",
    "/4 Marla/9.png",
    "/4 Marla/10.png",
    "/4 Marla/11.png",
    "/4 Marla/12.png",
    "/4 Marla/13.png",
    "/4 Marla/14.png",
    "/4 Marla/15.png",
    "/4 Marla/16.png",
];

export const fiveMarlaImages = [
    "/5 Marla/1.png",
    "/5 Marla/2.png",
    "/5 Marla/3.png",
    "/5 Marla/4.png",
    "/5 Marla/5.png",
    "/5 Marla/6.png",
    "/5 Marla/7.png",
    "/5 Marla/8.png",
    "/5 Marla/9.png",
    "/5 Marla/10.png",
    "/5 Marla/11.png",
    "/5 Marla/12.png",
    "/5 Marla/13.png",
    "/5 Marla/14.png",
    "/5 Marla/15.png",
    "/5 Marla/16.png",
];

export const viewsImages = [
    "/Housing Views/1.png",
    "/Housing Views/2.png",
    "/Housing Views/3.png",
    "/Housing Views/4.png",
    "/Housing Views/5.png",
    "/Housing Views/6.png",
    "/Housing Views/7.png",
    "/Housing Views/8.png",
    "/Housing Views/9.png",
    "/Housing Views/10.png",
    "/Housing Views/11.png",
    "/Housing Views/12.png",
    "/Housing Views/13.png",
];

export const apartmentImages = [
    "/Apartments/1.png",
    "/Apartments/2.png",
    "/Apartments/3.png",
    "/Apartments/4.png",
    "/Apartments/5.png",
    "/Apartments/6.png",
    "/Apartments/7.png",
    "/Apartments/8.png",
    "/Apartments/9.png",
    "/Apartments/10.png",
    "/Apartments/11.png",
    "/Apartments/12.png",
    "/Apartments/13.png",
    "/Apartments/14.png",
    "/Apartments/15.png",
];

export const demoImages = [
    "/Gallery Images/6.png",
    "/Gallery Images/2.png",
    "/Gallery Images/4.png",
    "/Gallery Images/1.png",
    "/Gallery Images/3.png",
    "/Gallery Images/5.png",
];
